// Where a tag opens in THIS frontend (kgshia-front). Each frontend has its own copy
// because routes differ per repo (backendhip/app/Chat/CLAUDE.md, "Tag routes per
// repo"). Types without a route here are hidden from the tag picker and can't be
// opened from a chat.
//
// List pages (no detail page yet) get ?focus=<id>.
const routes = {
  enrollee: (id) => `/client/${id}`,
  dependent: (id) => `/dependent/${id}`,
  provider: (id) => `/provider-${id}`,
  authorization_code: (id) => `/authorization-code/${id}`,
  claim: (id) => `/claim/${id}`,
  complaint: (id) => `/complaint/${id}`,
  service_summary: (id) => `/encounter/${id}`,
  appointment: (id) => `/appointment/${id}`,
  quality_assurance: (id) => `/accreditation/${id}`,
  form: (id) => `/accreditation-items?focus=${id}`,
  drug: (id) => `/manage-drugs?focus=${id}`,
  service: (id) => `/manage-services?focus=${id}`,
  payment_order: (id) => `/transaction/${id}`,
  finance: (id) => `/payment/transaction/${id}`,
  change_provider: (id) => `/change-facility-requests?focus=${id}`,
  vendor: (id) => `/procurement/vendors?focus=${id}`,
  inventory: (id) => `/my-inventories?focus=${id}`,
};

export const SUPPORTED_TYPES = Object.keys(routes);

export function entityRoute(type, id) {
  return routes[type] ? routes[type](id) : null;
}
